module.exports = __webpack_public_path__ + "assets/5883c4252443e99ecdd2d007b531303a.png";